import { Component } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { SidenavService } from '../../services/sidenav.service';

@Component({
  selector: 'app-stats',
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.scss'],
  standalone: false,
})
export class StatsComponent {
  sidenav: MatSidenav;

  constructor(
    private sidenavService: SidenavService,
    private router: Router,
  ) {
    this.sidenav = this.sidenavService.getSidenav();
  }

  toggleMenu() {
    this.sidenavService.toggle();
  }

  showEvolution() {
    this.router.navigate(['/stats/evolution']);
  }

  showSnipers() {
    this.router.navigate(['/stats/snipers']);
  }

  showBadges() {
    this.router.navigate(['/stats/badges']);
  }

  showScorers() {
    this.router.navigate(['/stats/scorers']);
  }

  showGroupStandings() {
    this.router.navigate(['/stats/group-standings']);
  }
}
